<template>
    <section class="inbannerBox">
        <img v-if="bannerUrl" :src="$root.$TEMP_URL+bannerUrl" />
        <div class="positionBox">
            <div class="wrapper">
                <div class="position_left">
                    <div class="position_tit wow slideInUp" data-wow-duration="1s" >{{positionInfo.second}}</div>
                    <div class="position_pos wow slideInUp" data-wow-duration="1s" >
                        <router-link to="/">{{isZhong?'首页':'HOME'}}</router-link>
                         >  {{positionInfo.second}}
                         <template v-if="positionInfo.third">
                            >  {{positionInfo.third}}
                         </template>
                         
                    </div>
                </div>
                <div class="position_ico"></div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props:{
        bannerUrl:String,
        positionInfo:Object
    },
    data(){
      return{
        isZhong:false
      }
    },
    created(){
        const language = this.$cookies.get('language');
        let isZhong;
        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        this.isZhong = isZhong; 
    

    },
    

};
</script>

<style lang="scss" scoped>
@import '../../common/css/mixin.scss';
//小鼠标动画
@-webkit-keyframes trackBallSlide {
  0% {
    opacity: 1;
    -webkit-transform: scale(1) translateY(-8px);
            transform: scale(1) translateY(-8px);
  }
  34% {
    opacity: 1;
    -webkit-transform: scale(0.9) translateY(4px);
            transform: scale(0.9) translateY(4px);
  }
  68% {
    opacity: 0;
    -webkit-transform: scale(0.4) translateY(16px);
            transform: scale(0.4) translateY(16px);
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(0.4) translateY(-8px);
            transform: scale(0.4) translateY(-8px);
  }
}
@keyframes trackBallSlide {
  0% {
    opacity: 1;
    -webkit-transform: scale(1) translateY(-8px);
            transform: scale(1) translateY(-8px);
  }
  34% {
    opacity: 1;
    -webkit-transform: scale(0.9) translateY(4px);
            transform: scale(0.9) translateY(4px);
  }
  68% {
    opacity: 0;
    -webkit-transform: scale(0.4) translateY(16px);
            transform: scale(0.4) translateY(16px);
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(0.4) translateY(-8px);
            transform: scale(0.4) translateY(-8px);
  }
}
@-webkit-keyframes nudgeMouse {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  50% {
    -webkit-transform: translateY(8px);
            transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  } 
}
@keyframes nudgeMouse {
  0% {
	    -webkit-transform: translateY(0);
            transform: translateY(0);
    }
    50% {
        -webkit-transform: translateY(8px);
        transform: translateY(8px);
    }
    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}

.inbannerBox {
  position: relative;
  width: 100%;
  img {
      width: 100%;
  }
  .positionBox {
    position:absolute;
    width: 100%;
    bottom: 44px;
    left: 0;
    .wrapper {
      @include flexFather;
      .position_left {
        flex: 1;  
        .position_tit {
            font-size: 22px;
            line-height: 24px;
            font-weight: bold;
            color: #fff;
            margin-bottom: 18px;
        }
        .position_pos {
          color: #fff;
          a {
              color: #fff;
          }
        }
      }
      .position_ico {
            width: 25px;
            height: 42px;
            cursor: pointer;
            -webkit-animation: nudgeMouse 1.6s linear infinite;
            animation: nudgeMouse 1.6s linear infinite;
            margin-left: 18px;
            @include boxSizing;
            border: 2px solid #fff;
            border-radius: 25px;
            &::after{
                content: "";
                position: absolute;
                background-color:#ffffff; 
                width:4px; height:4px; 
                border-radius:100%; 
                -webkit-animation:trackBallSlide 1.6s linear infinite; 
                animation:trackBallSlide 1.6s linear infinite; 
                top:0; right:0; bottom:0; left:0; margin:auto;
            }

      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BannerIn/BannerIn.vue